/**
 * AuthenticitySeal — the gold "Resmo Certified · Authenticity" stamp.
 *
 * Surfaces when a tailored resume has cleared the Integrity Check at 100/100
 * (every flagged claim verified or rewritten). Used in three spots:
 *   - Studio's Resume Honesty banner, large (~96px)
 *   - History card corner badge, small (~32px)
 *   - Anywhere else we want to show "this resume passed."
 *
 * Single image source — `/brand/resmo-seal-v2.png` (1024×1024 RGB). Wrapped
 * in a button-styled tooltip so hovering reveals a one-line description.
 *
 * Renders nothing when `verified` is falsy so the parent can just unconditionally
 * mount <AuthenticitySeal verified={...} /> without a wrapping {x && } gate.
 */
import React from "react";

export default function AuthenticitySeal({
  verified,
  size = 64,
  className = "",
  title = "Resume Monster Certified — every flagged claim verified at 100/100.",
  testId = "authenticity-seal",
}) {
  if (!verified) return null;
  return (
    <img
      src="/brand/resmo-seal-v2.png"
      alt="Resmo Authenticity Seal — 100/100"
      title={title}
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        // PNG now has real alpha (corner-connected white pixels were flood-
        // filled to alpha=0 via PIL in iteration_47), so no blend-mode hack
        // is needed — the seal sits cleanly on any background.
        filter: "drop-shadow(2px 3px 0 rgba(15,27,45,0.25))",
        userSelect: "none",
        pointerEvents: "auto",
        display: "block",
      }}
      className={className}
      data-testid={testId}
      draggable={false}
    />
  );
}
